import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import DriverDropdownCellSlot from '@components/DataGrid/DriverDropdownCellSlot';
import RenderCell from '@components/DataGrid/RenderCell';
import { CellProps } from '@components/DataGrid/types';
import DeliveryReceiptLink from '@components/DeliveryReceiptLink';
import MailLink from '@components/MailLink';
import PhoneLink from '@components/PhoneLink';
import SendDeliveryReceiptLink from '@components/SendDeliveryReceiptLink';

import styles from '../../RenderCell.module.css';

export default function DriverCell(props: CellProps<DispatchLeg>) {
  const { row } = props;
  // No leg (cancelled, closed/purged, or deleted) means there is nothing to assign a driver to.
  return !row.legId ? (
    <></>
  ) : (
    <RenderCell
      primarySlot={
        <DriverDropdownCellSlot
          legId={row.legId}
          legStatus={row.legStatus}
          cellText={row.drvName}
          legRequiresHazmatCertification={row.reqHazmatCert}
          isReminder={row.isReminder}
          tooltip={row.drvId && <DriverTooltip row={row} />}
        />
      }
      secondarySlot={
        row.tractorId && (
          <span
            className={styles['secondary-text']}
            title={`Truck: ${row.tractorId}`}>
            {row.tractorId}
          </span>
        )
      }
      tertiarySlot={
        <div className={styles['cell-actions']}>
          <div className={styles['cell-action']}>
            <SendDeliveryReceiptLink
              legId={row.legId}
              jobId={row.jobId}
              csnId={row.csnId}
              custRefNo={row.csnCustRefNo}
              bookingRefNo={row.bookingRefNo}
              cntrId={row.cntrId}
              driverCellPhone={row.drvCellPhone}
              driverEmail={row.drvEmailAddr}
              isHazmat={row.reqHazmatCert}
              isImport={row.jobCategoryTransportationType === 'Import'}
              isExport={row.jobCategoryTransportationType === 'Export'}
            />
          </div>
          <div className={styles['cell-action']}>{row.drvId && row.puDelvReceiptSent && <DeliveryReceiptLink legId={row.legId} />}</div>
          <div className={styles['cell-action']}>
            {row.drvId && (
              <MailLink
                emailAddress={row.drvEmailAddr ?? ''}
                showIcon={true}
              />
            )}
          </div>
          <div className={styles['cell-action']}>
            {row.drvId && (
              <PhoneLink
                phoneNumber={row.drvCellPhone ?? ''}
                showIcon={true}
              />
            )}
          </div>
        </div>
      }
    />
  );
}

function DriverTooltip(props: { row: DispatchLeg }) {
  const { row } = props;

  if (!row.drvId) return null;

  return (
    <span style={{ whiteSpace: 'pre-line' }}>
      {`${row.drvId ?? ''} - ${row.drvName ?? ''}\n
      ${row.drvCellPhone ?? '-'} • ${row.drvEmailAddr ?? '-'}\n
      CDL: ${row.cdlNo ?? '-'} • Plate: ${row.plateNo ?? '-'}`}
    </span>
  );
}
